//#region IMPORTS
import { promosSelectors } from "../../features/promos/promosSlice";
import { useAppSelector } from "../../store/configureStore";
import { useTranslation } from "react-i18next";
import { Basket } from "../../models/basket";
import ContinueButton from "../genericButtons/continueButton/ContinueButton";
// import AdcLogo from "../logos/AdcLogo";
//#endregion

//#region INTERFACE
interface Props {
  isPicker: boolean;
  isAdmin: boolean;
  HQTeam: boolean;
  basket: Basket | null;
}
//#endregion

export default function HomeFooter({
  isPicker,
  isAdmin,
  HQTeam,
  basket,
}: Props) {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Redux
  const currentPromo = useAppSelector(
    (state) => basket && promosSelectors.selectById(state, basket.promo_id)
  );
  const instoreBasketTemplateId = useAppSelector(
    (state) => state.instoreBasket.template_id
  );
  const instoreBasketItems = useAppSelector(
    (state) => state.instoreBasket.items
  );
  //#endregion

  //#region RENDER
  return (
    <footer className="hidden lg:flex lg:justify-between lg:items-end [grid-area:ft]">
      {!HQTeam && !isAdmin && !isPicker ? (
        <div className="text-base text-slate-500">
          <p>
            {currentPromo
              ? `${t("rituals.myCurrentSelectedProjectIs")} ${currentPromo.code}`
              : instoreBasketItems.length > 0
                ? "You have an instore order in your basket"
                : t("rituals.noCurrentSelectedProject")}
          </p>
        </div>
      ) : (
        <div className="text-sm text-slate-500">
          <a
            href="https://www.albedecoker.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2"
          >
            <p>powered by Albe De Coker</p>
            {/* <AdcLogo className="w-24 h-auto" /> */}
          </a>
        </div>
      )}

      {basket && (
        <ContinueButton
          color="#000000"
          value={t("rituals.basket")}
          to="/basket"
        />
      )}

      {instoreBasketTemplateId && instoreBasketItems.length > 0 && (
        <ContinueButton
          color="#000000"
          value={t("rituals.basket")}
          to={`/promos/instore/${instoreBasketTemplateId}`}
        />
      )}
    </footer>
  );
  //#endregion
}
